export default __webpack_public_path__ + "static/media/photo_gallery_8.6c58b73f.png";